import React from 'react';
import { motion } from 'framer-motion';
const stats = [{
  value: 'Est. 1923',
  label: 'Heritage'
}, {
  value: '50 Acres',
  label: 'Estate Grounds'
}, {
  value: '500+',
  label: 'Celebrations Hosted'
}, {
  value: '3',
  label: 'Unique Venues'
}];
export function Stats() {
  return <section className="bg-charcoal texture-grain py-16 md:py-20 relative" data-id="element-271">
      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-272">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-y-12 md:gap-y-0 md:divide-x md:divide-cream/10" data-id="element-273">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="flex flex-col items-center text-center px-4" data-id="element-274">
              <span className="font-serif text-3xl md:text-4xl lg:text-5xl text-copper mb-3" data-id="element-275">
                {stat.value}
              </span>
              <span className="font-sans text-[10px] md:text-xs tracking-[0.2em] uppercase text-cream/60" data-id="element-276">
                {stat.label}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}